import { Component, OnInit, Input, ViewChild, ElementRef, PipeTransform } from '@angular/core';

import { HttpClientProvider } from 'src/app/services/http-client';

import * as ace from "ace-builds";
declare var $: any;

@Component({
  selector: 'app-code-viewer',
  templateUrl: './code-viewer.component.html',
  styleUrls: ['./code-viewer.component.scss']
})
export class CodeViewerComponent implements OnInit {

  @Input() typeview: string;

  @Input() code;

  
  @ViewChild("editor") private editor: ElementRef<HTMLElement>;

  constructor(
    private http: HttpClientProvider,
  ) {

  }

  ngAfterViewInit(): void {
    console.log(this.typeview);
    ace.config.set("fontSize", "14px");
    // ace.config.set("basePath", "https://ace.c9.io/build/src-noconflict/ace.js");
    ace.config.set("basePath", "https://unpkg.com/ace-builds@1.4.12/src-noconflict");
    const aceEditor = ace.edit(this.editor.nativeElement);
    aceEditor.session.setValue(this.transform(this.code));
    aceEditor.setTheme("ace/theme/twilight");
    aceEditor.session.setMode("ace/mode/html");
    // aceEditor.renderer.attachToShadowRoot();
    aceEditor.setReadOnly(true);
    aceEditor.on("change", () => {
      console.log(aceEditor.getValue());
    });

  }

  transform(value: any): string {
    return JSON.stringify(value, null, 4);
  }

  ngOnInit(): void {
    
  }
}